import styled from "styled-components";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { formattedDate, dateFormat, toDate } from "@/app/utils/DayJS";
import Placing from "@/app/ui/Common/Placing";
import { GET_RACE_INFO_LIST } from "@/app/utils/request/query";
import { getRaceInfoList } from "@/app/utils/request/requestList";
import { useState, useEffect } from "react";
import { LANGTYPE_EN, useLanguage } from "@/app/utils/LanguageContext";
import { textSize, text_size } from "@/app/utils/MixinSize";
import GearInfo from "../GearInfo";
import _ from "lodash";
import { formattedNumber } from "@/app/utils/Common";
import { useMyContext } from "@/app/utils/MyContext";
import Loading from "@/app/ui/Common/Loading";
import VideoPlayerIconBlue from "@/app/ui/Common/SvgComponent/VideoPlayerIconBlue";
const Container = styled.div`
  padding: 0 12px 56px;
`;
const MyTableContainer = styled(TableContainer)`
  border-radius: 0 0 4px 4px;
`;
const FirstColumCell = styled(TableCell)`
  background: white;
  padding-top: 4px;
  border-bottom: none;
`;

const CustomTableCell = styled(TableCell)`
  &.${tableCellClasses.head} {
    background: var(--Secondary, #6176A0);
    ${text_size(11)}
    padding: 8px;
    font-weight: 400;
    border-bottom: none;
    color: white;
    vertical-align: top;
  }
  &.${tableCellClasses.body} {
    white-space: nowrap;
    padding: 4px 0;
    ${text_size(13)}
    font-weight: 500;
    border-bottom: none;
    background: white;
    vertical-align: top;
  }
`;
const CustomRowOneCell = styled(TableCell)`
  &.${tableCellClasses.body} {
    padding: 6px 12px;
    background: rgba(244, 244, 244, 1);
    ${text_size(13)}
    font-weight: 500;
    line-height: 17px;
    color: rgba(51, 51, 51, 1);
  }
`;
const SpecilRowText = styled.div`
  display: flex;
  align-items: center;
  p {
    ${text_size(13)}
    font-weight: 500;
    line-height: 17px;
    color: rgba(51, 51, 51, 1);
    width: 106px;
  }
  span {
    ${text_size(13)}
    font-weight: 500;
    line-height: 17px;
    color: rgba(51, 51, 51, 1);
  }
`;
const WinnerComments = styled.div`
  margin-top: -20px;
  padding: 0 0 8px 8px;
  div {
    display: flex;
    margin-bottom: 4px;
    div {
      display: flex;
      align-items: center;
      width: auto;
      p {
        color: rgba(18, 44, 104, 1);
        ${text_size(11)}
        font-weight: 400;
        text-align: left;
        margin: 0;
        line-height:21px;
      }
      img {
        vertical-align: middle;
        margin-right: 6px;
      }
    }
    & p {
      margin-left: 12px;
      ${text_size(13)}
      font-weight: 500;
      line-height: 16px;
      text-align: left;
      color: black;
      white-space: pre-wrap;
      max-width: 800px;
    }
    @media only screen and (max-width: 1200px) {
      p {
          max-width: 690px;
      }
    }
  }
`;
const FinishMargin = styled.div`
  display: flex;
  justify-content: center;
  span {
    padding-top: 4px;
    ${text_size(13)}
    font-weight: 500;
    text-align: left;
    align-self: flex-end;
    color: rgba(51, 51, 51, 1);
  }
  p {
    margin-left: 4px;
    ${text_size(11)}
    font-weight: 500;
    text-align: left;
    right: 0;
    color: rgba(51, 51, 51, 1);
    align-self: flex-start;
  }
`;

const DetailTable = (props: any) => {
  const { data, raceNo, type, horseId, dynamicColumn } = props;
  const { state: myContextState } = useMyContext();
  const { state: lang } = useLanguage();
  const { t } = lang;
  const [infoData, setInfoData] = useState<any>([]);
  const [showSecTime, setShowSecTime] = useState(false);
  const [showRaceTime, setShowRaceTime] = useState(false);
  const [showPosRun, setShowPosRun] = useState(false);
  const [showFM, setShowFM] = useState(false);
  const [showOdds, setShowOdds] = useState(false);
  const [showMed, setShowMed] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [loading, setLoading] = useState(true);
  const ON_RELEASE1B = window.globalConfig?.OneBSwitch;

  const setColShow = (record: any) => {
    if (type === "horseProfile") {
      record.map((item: any) => {
        if (getRaceSplitTime(item.sectionTimeSplits) !== "-") {
          setShowSecTime(true);
        }
        if (item.finalTimeOfRace) {
          setShowRaceTime(true);
        }
        if (getPosInRunning(item.sectionInfos) !== "-") {
          setShowPosRun(true);
        }
        if (item.marginOrLBW?.code) {
          setShowFM(true);
        }
        if (item.winOdds && item.winOdds !== "-") {
          setShowOdds(true);
        }
        if (lang.langType === LANGTYPE_EN) {
          if (item.med?.english) {
            setShowMed(true);
          }
          if (item.comments?.english) {
            setShowComments(true);
          }
        } else {
          if (item.med?.chinese) {
            setShowMed(true);
          }
          if (item.comments?.english) {
            setShowComments(true);
          }
        }
      });
    } else {
      setShowSecTime(dynamicColumn.sectionTime);
      setShowRaceTime(dynamicColumn.finalTimeOfRace);
      setShowPosRun(dynamicColumn.sectionInfos);
      setShowFM(dynamicColumn.marginOrLBW);
      setShowOdds(dynamicColumn.winOdds);
      setShowMed(dynamicColumn.med);
      setShowComments(dynamicColumn.comments);
    }
  };
  useEffect(() => {
    if (type === "horseProfile") {
      if (data) {
        getRaceInfoList(
          {
            ids: [data.id],
            meetingDate: data.id?.split("S")[0],
            raceNumber: `${raceNo}`,
          },
          GET_RACE_INFO_LIST,
          "qids"
        )
          .then((res: any) => {
            const formRecord = res.simulcastHorse[0]?.horseFormRecord;
            setColShow(formRecord);
            setInfoData(formRecord);  
          })
          .catch((e) => {
            console.log(e);
          }).finally(() => { 
            setLoading(false);
          });;
      }
    } else {
      const formRecord = data?.filter((item: any) =>
        item.id?.includes(horseId)
      )?.[0]?.horseFormRecord;
      console.log("formRecord", formRecord);

      setColShow(formRecord);
      setInfoData(formRecord);
      setLoading(false);
    }
  }, [data]);
  const headCells: any = [
    {
      id: "place",
      label: t("race_card_pla"),
      width: 140,
      textAlign: "center",
      show: true,
      customStyle: {
        textAlign: "left",
        paddingLeft: "12px",
      }
    },
    {
      id: "track",
      label: t("race_card_track"),
      width: 120,
      textAlign: "left",
      show: true,
    },
    {
      id: "DCG",
      label: t("race_card_DCG"),
      width: 280,
      textAlign: "left",
      show: true,
    },
    {
      id: "wt",
      label: t("race_card_WT"),
      width: 120,
      textAlign: "center",
      show: true,
    },
    {
      id: "jockey",
      label: t("race_card_jockey"),
      textAlign: "left",
      width: 220,
      show: true,
    },
    {
      id: "dr",
      label: t("race_card_Dr"),
      width: 100,
      textAlign: "center",
      show: true,
    },
    {
      id: "sectionalTime",
      label: t("race_card_RST"),
      textAlign: "center",
      width: 280,
      show: showSecTime,
    },
    {
      id: "raceTime",
      label: t("race_card_race_time"),
      width: 140,
      textAlign: "center",
      show: showRaceTime,
    },
    {
      id: "posInRunning",
      label: t("race_card_position"),
      textAlign: "center",
      width: 240,
      show: showPosRun,
    },
    {
      id: "finishMargin",
      label: t("race_card_finish_margin"),
      textAlign: "center",
      width: 140,
      show: showFM,
    },
    {
      id: "odds",
      label: t("race_card_odds"),
      textAlign: "center",
      width: 100,
      show: showOdds,
    },
    {
      id: "gear",
      label: t("race_card_gear"),
      textAlign: "center",
      width: 100,
      show: true,
    },
    {
      id: "med",
      label: t("race_card_med"),
      textAlign: "center",
      width: 100,
      show: showMed, 
    },
  ];
  const getDCG = (info: any) => {
    const distance = info?.distance;
    const cou =
      info?.raceTurn?.code && lang.langType === LANGTYPE_EN
        ? info.raceTurn?.code
        : info.raceTurn?.chinese;
    const going =
      info?.going?.code && lang.langType === LANGTYPE_EN
        ? info.going?.english
        : info.going?.chinese;
    const track = 
      info?.track?.code && lang.langType === LANGTYPE_EN
        ? info?.track?.english
        : info?.track?.chinese;
    return `${distance}/${cou ?? info?.raceTurn?.code ?? "-"}/${going}/${track}`;
  };
  const getRaceSplitTime = (splitTime: any) => {
    let result = "-";
    let hasSplitTime = false;
    if (splitTime?.length) {
      let timeArr = [];
      timeArr = splitTime?.map((item: any) => {
        if (item.sectionTime) {
          hasSplitTime = true;
          return item.sectionTime;
        } else {
          return ` - `;
        }
      });
      result = timeArr.join(" ");
    }
    return hasSplitTime ? result : "-";
  };
  const getPosInRunning = (posInfo: any) => {
    let result = "-";
    let hasPos = false;
    if (posInfo?.length) {
      let posArr = [];
      posArr = posInfo?.map((item: any) => {
        if (item.ruPos !== -1) {
          hasPos = true;
          return item.ruPos;
        } else {
          return "-";
        }
      });
      result = posArr.join(" ");
    }
    return hasPos ? result : "-";
  };
  const getWinners = (winners: any) => {
    const newWinners = _.orderBy(winners, ["pos"], ["asc"]); 
    let result = "";
    const winners1 = winners?.filter((x: any) => x.pos == 1);
    const winners2 = winners?.filter((x: any) => x.pos == 2);
    const winners3 = winners?.filter((x: any) => x.pos == 3);

    const w1 = winners1?.length > 0 ? handleWinners(winners1, lang.langType) : "-";
    const w2 = winners2?.length > 0 ? handleWinners(winners2, lang.langType) : "-";
    const w3 = winners3?.length > 0 ? handleWinners(winners3, lang.langType) : "-";

    result = `${w1} / ${w2} / ${w3}`;
 
    // const win1 = lang.langType === LANGTYPE_EN ? `${winners?.[0]?.name.english} (${winners?.[0]?.cnty.english})`: `${winners?.[0]?.name.chinese} (${winners?.[0]?.cnty.chinese})`;
    // const win2 = lang.langType === LANGTYPE_EN ? `${winners?.[1]?.name.english} (${winners?.[1]?.cnty.english})` : `${winners?.[1]?.name.chinese} (${winners?.[1]?.cnty.chinese})`;
    // const win3 = lang.langType === LANGTYPE_EN ? `${winners?.[2]?.name.english} (${winners?.[2]?.cnty.english})` : `${winners?.[2]?.name.chinese} (${winners?.[2]?.cnty.chinese})`;
 
    // if (lang.langType === LANGTYPE_EN) {
    //   result = `${winners?.[0]?.name.english ? win1 : '-'} / ${winners?.[1]?.name.english ? win2 : '-'} / ${winners?.[2]?.name.english ? win3 : '-'}`;
    //   //result = `${winners?.[0]?.name.english} (${winners?.[0]?.cnty.english}) / ${winners?.[1]?.name.english} (${winners?.[1]?.cnty.english}) / ${winners?.[2]?.name.english} (${winners?.[2]?.cnty.english})`;
    // } else {
    //   result = `${winners?.[0]?.name.chinese ? win1 : '-'} / ${winners?.[1]?.name.chinese ? win2 : '-'} / ${winners?.[2]?.name.chinese ? win3 : '-'}`;
    //   //result = `${winners?.[0]?.name.chinese} (${winners?.[0]?.cnty.chinese}) / ${winners?.[1]?.name.chinese} (${winners?.[1]?.cnty.chinese}) / ${winners?.[2]?.name.chinese} (${winners?.[2]?.cnty.chinese})`;
    // }
    return result;
  };
  const handleWinners =(wins: any, langType: string) => {
    let result = "";
    wins?.forEach((x: any) => {
      result =  lang.langType === LANGTYPE_EN ? `${result !="" ? result + ", " : ""}${x.name.english} (${x.cnty.english})` : `${result !="" ? result + "," : ""}${x.name.chinese} (${x.cnty.chinese})`;
      //result =  `${result} ${lang.langType === LANGTYPE_EN ? `${x.name.english} (${x.cnty.english})` : `${x.name.chinese} (${x.cnty.chinese})`}`; 
    })
    return result;
  }

  const CustomTableRow = (props: any) => {
    const { info } = props;
    const [showGearLegend, setShowGearLegend] = useState(false);

    const handleClickGear = (e: any) => {
      setShowGearLegend(true);
      setTimeout(() => {
        const gearElementsB = e.target?.getElementsByTagName("div")[0];
        const pos = e.target.getBoundingClientRect();
        console.log("handleClickGear",pos , e)
        if (gearElementsB) {
          gearElementsB.style.display = "block";
          gearElementsB.style.position = "fixed";
          gearElementsB.style.top = `${Number(pos.top ?? 0) - gearElementsB.offsetHeight}px`;
          
          // `${
          //   e.target.offsetTop - gearElementsB.offsetHeight + 204
          // }px`;
          gearElementsB.style.left = `${
            e.target.offsetLeft - (600 - e.target.offsetWidth / 1.2)
          }px`;
        }
      }, 300);
    };
    const handleLeaveGear = () => {
      setShowGearLegend(false);
    };

    const getConditionInfo = (info: any) => {
      const className = info.className?.code ? info.className?.code + " " : "";
      const raceName = info.raceName?.code ? lang.langType === LANGTYPE_EN ? info.raceName?.english + " " : info.raceName?.chinese + " " : "";
      const ageCondition = lang.langType === LANGTYPE_EN ? info.ageCondition?.english : info.ageCondition?.chinese;
      const condition = lang.langType === LANGTYPE_EN ? info.condition?.english : info.condition?.chinese;
      const currency = lang.langType === LANGTYPE_EN ? info.currency?.english : info.currency?.chinese;
      return`${className}${raceName}${ageCondition} ${condition} ${currency} ${info?.prizeMoney && formattedNumber(Number(info?.prizeMoney))}`
    }

    const getTrack = (info: any) => {
      const course = info.course?.code ? lang.langType === LANGTYPE_EN ? info.course?.code : info.course?.chinese : "-";
      const country = info.cntyShortNm?.code ? lang.langType === LANGTYPE_EN ? info.cntyShortNm?.english : info.cntyShortNm?.chinese : "-";
      return `${course}, ${country}`
    }

    return (
      <>
        <TableRow>
            <CustomRowOneCell>
              {formattedDate(toDate(info?.date, dateFormat.qids.date), dateFormat.display.date)}
            </CustomRowOneCell>
            <CustomRowOneCell colSpan={16} style={{paddingLeft: 8}}> 
                {getConditionInfo(info)} 
            </CustomRowOneCell>
        </TableRow>
        <TableRow>
          <FirstColumCell align="center">
            <Placing
              placing={info?.ruPlace}
              totalRunners={info?.numOfStarters ? info.numOfStarters : 18}
              type="pc"
            ></Placing>
          </FirstColumCell>
          <CustomTableCell align="left" style={{paddingLeft: 8}}>
            {getTrack(info)}
          </CustomTableCell>
          <CustomTableCell align="left" style={{paddingLeft: 8}}>{getDCG(info)}</CustomTableCell>
          <CustomTableCell align="center">
            {info.actualWeight ? info.actualWeight : "-"}
          </CustomTableCell>
          <CustomTableCell align="left">
            {info.jockey?.code
              ? lang.langType === LANGTYPE_EN
                ? info.jockey?.name_en
                : info.jockey?.name_ch
              : "-"}
          </CustomTableCell>
          <CustomTableCell align="center">
            {info.barrierDrNo && info.barrierDrNo > 0 ? info.barrierDrNo : "-"}
          </CustomTableCell>
          {showSecTime ? (
            <CustomTableCell align="center">
              {getRaceSplitTime(info.sectionTimeSplits)}
            </CustomTableCell>
          ) : null}
          {showRaceTime ? (
            <CustomTableCell align="center">
              {info.finalTimeOfRace ? info.finalTimeOfRace : "-"}
            </CustomTableCell>
          ) : null}
          {showPosRun ? (
            <CustomTableCell align="center">
              {getPosInRunning(info.sectionInfos)}
            </CustomTableCell>
          ) : null}
          {showFM ? (
            <CustomTableCell align="center">
              <FinishMargin>
                <span>{info.placeNo ? info.placeNo : "-"}</span>
                <p>{lang.langType === LANGTYPE_EN ?
                  info.marginOrLBW?.english ? info.marginOrLBW?.english : "-"
                  : 
                  info.marginOrLBW?.chinese ? info.marginOrLBW?.chinese : "-"}
                </p>
              </FinishMargin>
            </CustomTableCell>
          ) : null}
          {showOdds ? (
            <CustomTableCell align="center">              

              {info.winOdds ? info.winOdds + (info.fav ? `(${info.fav})` : "") : "-"}
            </CustomTableCell>
          ) : null}
          <CustomTableCell
            align="center"
            sx={{ cursor: "pointer", color: "#122c68" }}
            onClick={handleClickGear}
            onMouseLeave={handleLeaveGear}
          >
            {info.gear ? info.gear : "-"}
            {showGearLegend &&
              info.gear != "" &&
              props?.gearData?.length > 0 && (
                <GearInfo gear={info.gear} gearData={props.gearData}></GearInfo>
              )}
          </CustomTableCell>
          {showMed ? (
            <CustomTableCell align="center">
              {lang.langType === LANGTYPE_EN
                ? info.med?.english
                  ? info.med?.english
                  : "-"
                : info.med?.chinese
                ? info.med?.chinese
                : "-"}
            </CustomTableCell>
          ) : null}
        </TableRow>
        <TableRow>
          <CustomTableCell>
            {ON_RELEASE1B && props.idxKey == 0  && props?.rowData?.videoReplayLink && <div style={{position: "relative"}}>
              <VideoPlayerIconBlue style={{position: "absolute", top: -12, left: 16, cursor: "pointer", width:24, height:24 }} onClick={() => props?.onRunReplayItemClick(props?.rowData)}/></div>}
          </CustomTableCell>
          <CustomTableCell colSpan={16}>
            <WinnerComments>
              <div style={{ float:"left", display:"inline-block" }}>
                <div>
                  <img src={`${myContextState.assetPrefix}/race_card_winner.svg`} />
                  <p>{t("race_card_WST")}</p>
                </div>
                <div style={{display:showComments ?"" :"none"}}>
                    <img src={`${myContextState.assetPrefix}/race_card_comments.svg`} />
                    <p>{t("race_card_comments")}</p>
                  </div>                                
              </div>
              <div style={{ float:"left", display:"inline-block" }}>
                <p style={{ lineHeight:"21px", paddingBottom:"4px" }}>{getWinners(info.winners)}</p>
                <p style={{ lineHeight:"21px", paddingBottom:"4px", display:showComments ?"" :"none" }} >
                  {lang.langType === LANGTYPE_EN
                      ? info.comments?.english ? info.comments?.english : "-"
                      : info.comments?.chinese ? info.comments?.chinese : "-"
                    }
                </p>
              </div>
            </WinnerComments>
          </CustomTableCell>
        </TableRow>
      </>
    );
  };
  return (
    <>
    {loading? <Loading />: null}
    <Container style={{ padding: 0 , display: loading ? "none" : ""}}>
      <MyTableContainer>
        <Table id="horse_profile_table" sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
          <TableHead>
            <TableRow>
              {headCells.map(
                (cell: any) =>
                  cell.show && (
                    <CustomTableCell
                      key={cell.id}
                      align={cell.textAlign}
                      sx={{ width: `${cell.width}px` }}
                      style={{
                        ...cell?.customStyle,
                      }}
                    >
                      {cell.label}
                    </CustomTableCell>
                  )
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {infoData?.map((info: any, index: any) => (
              <CustomTableRow
                key={index}
                info={info}
                gearData={props.gearData}
                idxKey={index}
                rowData={props?.rowData}
                onRunReplayItemClick={props?.onRunReplayItemClick}
              />
            ))}
          </TableBody>
        </Table>
      </MyTableContainer>
    </Container>
    </>
  );
};
export default DetailTable;
